function initializeAlerts() {
  const alerts = document.querySelectorAll(".alert:not(.static)");

  alerts.forEach((alert) => {

    // auto dismiss
    setTimeout(() => {
      alert.classList.remove("show");
      setTimeout(() => alert.remove(), 400);
    }, 5000);

    // close button
    const close = alert.querySelector(".custom-alert-close");

    if (close) {
      close.addEventListener("click", (e) => {
        e.preventDefault();

        alert.classList.remove("show");

        setTimeout(() => alert.remove(), 400);
      });
    }

  });
}

document.addEventListener("turbo:load", initializeAlerts);
document.addEventListener("turbo:frame-load", initializeAlerts);
document.addEventListener("turbo:before-stream-render", () => {
  setTimeout(initializeAlerts, 10);
});